export default "__VITE_ASSET__V5EJl7cF__"